module.exports = __webpack_public_path__ + "static/media/82.36ee1f15.jpg";